import { ATDLParameterDataModel } from "./atdl-parameter-data.model";
import { ATDLInterfaceLayoutModel } from "./atdl-interface-layout.model";
import { ATDLValidationCaseModel } from "./atdl-validation-case.model";
import { ATDLInterfaceControlModel } from "./atdl-interface-control.model";
import { ATDLLayoutControlModel } from "./atdl-layout-control.model";
import { ICDNAuxMode } from "../../data-idc/enums/icd-aux-mode.enum";
import { ATDLInterfaceAuxiliaryModel } from "app/order-entry/data-atdl/model/atdl-interface-auxiliary.model";

export type ATDLCommonControlType = ATDLInterfaceControlModel | ATDLInterfaceAuxiliaryModel;

export class ATDLDataModel {
  // GENERAL  [location: .Strategies.Strategy.$ ]
  public id: string = null; // Database column (in theory should correspond with name)
  public description: string = null; // Database column (in theory should correspond with uiRep)
  public name: string = null; // Algo name - server reference
  public uiRep: string = null; // Display name - ui friendly name
  public version: string = null;
  public wireValue: string = null; // Algo value - server strategy reference
  // PARAMETERS [location: .Strategies.Strategy.Paramter -> array -> $]
  public parameters: Array<ATDLParameterDataModel> = null;
  // LAYOUT & CONTROLs [location: .Strategies.lay:StrategyLayout.lay:StrategyPanel.lay:StrategyControl -> array -> $]
  public layouts: Array<ATDLInterfaceLayoutModel> = null;
  public controls: Array<ATDLInterfaceControlModel> = null;

  /** Controls above plus additional internal aux controls that can be referenced in StateRules */
  private _fullControls: Array<ATDLCommonControlType> = null;

  // VALIDATION
  public validation: Array<ATDLValidationCaseModel> = null;
  /////////////////////////////////////
  // UI - Generated
  public layoutStructure: Array<Array<ATDLLayoutControlModel>> = [];

  // Limit price override
  public limitPriceMode: ICDNAuxMode = null;

  /**
   * Get full set of controls that include explicit models for aux checkboxes. THese
   * are lazily created to ensure that they are resolved after a clone operation
   */
  public get fullControls(): Array<ATDLCommonControlType> {
    if (this._fullControls === null) {
      this._fullControls = this.createFullControls();
    }
    return this._fullControls;
  }

  private createFullControls(): Array<ATDLCommonControlType> {
    // As logicoperator StateRules can reference aux values, we need to add references to these models
    // to the ATDLDataModel so they can be accessed during StateRule validation
    const auxModels = [];
    this.controls.forEach((item) => {
      if (item.auxiliary?.length === 1) {
        auxModels.push(item.auxiliary[0]);
      }
    });
    return this.controls.concat(auxModels);
  }
}
